import { useCallback, useRef, useState } from "react";
import { FilterOption, GeneralFacet } from "../types";

const useMultiselectFilter = (
  filter: Omit<GeneralFacet & { data: FilterOption[] }, "type" | "sortOrder">,
  onSelection?: (...args) => void
) => {
  const { data: filterOptions, ...restFilterData } = filter;
  const restFilterDataRef = useRef(restFilterData);
  restFilterDataRef.current = restFilterData;

  const [selectedOptions, setSelectedOptions] = useState<FilterOption[]>([]);
  const selectedOptionsRef = useRef<FilterOption[]>([]);
  selectedOptionsRef.current = selectedOptions;

  const onFilterOptionClick = useCallback(
    ({ option }, event) => {
      event.stopPropagation();
      const prev = selectedOptionsRef.current;
      const updatedOptions = prev.some(
        selectedOption => selectedOption.key === option.key
      )
        ? prev.filter(selectedOption => selectedOption.key !== option.key)
        : [...prev, option];

      setSelectedOptions(updatedOptions);

      onSelection?.({
        ...restFilterDataRef.current,
        selectedOptions: updatedOptions
      });
    },
    [onSelection]
  );

  const clearSelectedOptions = useCallback(() => {
    setSelectedOptions([]);
    onSelection &&
      onSelection({
        ...restFilterDataRef.current,
        selectedOptions: []
      });
  }, [onSelection]);

  return {
    filterOptions,
    selectedOptions,
    onFilterOptionClick,
    clearSelectedOptions,
    setSelectedOptions
  };
};

export default useMultiselectFilter;
